import { useEffect, useState } from "react";
import { company, navLinks } from "../constants";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-noir/90 backdrop-blur border-b border-white/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <nav className="section-container flex items-center justify-between">
        <a href="#hero" className="font-display font-extrabold text-lg tracking-tight">
          {company.name.split(" ")[0]}
          <span className="text-ferrari">.</span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-chrome-dark hover:text-white transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>

        <a href="#rendez-vous" className="btn-primary !px-5 !py-2.5 text-sm">
          Prendre RDV
        </a>
      </nav>
    </header>
  );
};

export default Navbar;
